import React from 'react'

import LogoBlock from './LogoBlock'

import { getBottomOptions, getTopOptions, createNavItem } from './helpers'
import useAccess from '../../../hooks/useAccess'
import useStyles from './styles'

const SideNav = () => {
  const hasPermission = useAccess()

  const classes = useStyles()

  const navOptions = React.useMemo(
    () => getTopOptions(hasPermission).map(createNavItem(classes)),
    [hasPermission, classes]
  )

  const settingsOptions = React.useMemo(
    () => getBottomOptions(hasPermission).map(createNavItem(classes)),
    [hasPermission, classes]
  )

  return (
    <div className={classes.root}>
      <LogoBlock className={classes.logo} />

      {/* Agent items */}
      {navOptions}

      {settingsOptions}
    </div>
  )
}

export default SideNav
